import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  InvoiceTemplateBean,
  InvoiceTemplateSearchCriteria,
  RestInvoiceTemplateListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class InvoiceTemplateListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editInvoiceTemplate = (e, val, rowdata) => {
    if (e.detail === 1) this.props.editInvoiceTemplate(val, rowdata);
  };
  deleteInvoiceTemplate = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteInvoiceTemplate(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  render() {
    let invoiceTemplate_list = this.props.invoiceTemplate_list;
    let invoiceTemplateData = this.props.invoiceTemplateData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">InvoiceTemplate</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                onChange={this.props.onChange}
                value={invoiceTemplateData.code}
                style={{ "text-transform": "uppercase" }}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {invoiceTemplate_list != null ? (
              <tbody>
                {invoiceTemplate_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editInvoiceTemplate(e, Info.code)}
                      >
                        {Info.code}
                      </Button>
                    </td>

                    <td> {Info.description}</td>

                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteInvoiceTemplate(e, Info.code)
                        }
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {invoiceTemplate_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class InvoiceTemplateEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();

    this.state = {
      showHide: this.props.showHide,
      invoiceTemplateData: this.props.invoiceTemplateData,
    };
  }

  componentDidMount() {
    this.setInputFocus();
  }

  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }

  onChange = (e) => {
    this.props.onChange(e);
  };

  saveInvoiceTemplate = (e) => {
    this.props.saveInvoiceTemplate(this.state.invoiceTemplateData);
  };

  closeInvoiceTemplateEntryForm() {
    this.props.closeInvoiceTemplateEntryForm();
  }

  render() {
    let invoiceTemplateData = this.props.invoiceTemplateData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={invoiceTemplateData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter InvoiceTemplateCode"
              onChange={this.onChange}
              value={invoiceTemplateData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={invoiceTemplateData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={invoiceTemplateData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class InvoiceTemplateList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      invoiceTemplate_list: [],
      response: {},
      pageTitle: "Invoice Template",
      invoiceTemplateData: new InvoiceTemplateBean(),
      pageList: new PageListBean(),
      criteria: new InvoiceTemplateSearchCriteria(),
      companyCode: "",

      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isInvoiceTemplateListFormOpen: true,
      isInvoiceTemplateEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,

      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
    this.setState({ isShowCode: false });
  }

  moduleCaption = "Invoice Template";

  cleardata = () => {
    let invoiceTemplateData = new InvoiceTemplateBean();
    invoiceTemplateData.companyCode = this.companyCode;
    this.setState({ invoiceTemplateData: invoiceTemplateData });
  };
  opentypeforms = () => {
    let invoiceTemplateCode = this.state.invoiceTemplateData;
    this.editInvoiceTemplate(invoiceTemplateCode.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  saveInvoiceTemplateResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeInvoiceTemplateEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };

  saveInvoiceTemplate = (invoiceTemplateData) => {
    if (invoiceTemplateData.isFetched == true) {
      if (SecurityAccessManager.InvoiceTemplateMaintenanceEdit_IsAccessible()) {
        MasterService.updateInvoiceTemplate(
          invoiceTemplateData,
          this.saveInvoiceTemplateResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.InvoiceTemplateMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createInvoiceTemplate(
          invoiceTemplateData,
          this.saveInvoiceTemplateResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  editInvoiceTemplateResponse = (response) => {
    if (response.data != null) {
      if (response.data.invoiceTemplateBean != null) {
        let invoiceTemplateData = response.data.invoiceTemplateBean;
        this.setState({
          invoiceTemplateData: invoiceTemplateData,
        });
        this.disable();
      }
    }
    this.openInvoiceTemplateEntryForm();
  };

  editInvoiceTemplate = (invoiceTemplateCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = invoiceTemplateCode;
    if (SecurityAccessManager.InvoiceTemplateMaintenanceView_IsAccessible()) {
      MasterService.readInvoiceTemplate(
        readrestInput,
        this.editInvoiceTemplateResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let temp_invoiceTemplatedata = this.state.invoiceTemplateData;
    temp_invoiceTemplatedata[e.target.name] = e.target.value;
    this.setState({
      invoiceTemplateData: temp_invoiceTemplatedata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let invoiceTemplateData = this.state.invoiceTemplateData;
    invoiceTemplateData.companyCode = this.companyCode;
    invoiceTemplateData.code =
      this.state.invoiceTemplateData.code.toUpperCase();
    this.clearError();
    this.saveInvoiceTemplate(invoiceTemplateData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeInvoiceTemplateEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openInvoiceTemplateEntryForm = () => {
    this.setState({
      isInvoiceTemplateListFormOpen: false,
      isInvoiceTemplateEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeInvoiceTemplateEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isInvoiceTemplateListFormOpen: true,
      isInvoiceTemplateEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,

      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };

  deleteInvoiceTemplate = (code, rowData) => {
    //
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadInvoiceTemplateResponse = (response) => {
    if (
      response.data != null &&
      response.data.invoiceTemplatePageList != null
    ) {
      let invoiceTemplateList = new Array();
      if (
        !isEmptyArray(response.data.invoiceTemplatePageList.invoiceTemplate)
      ) {
        invoiceTemplateList =
          response.data.invoiceTemplatePageList.invoiceTemplate;
        invoiceTemplateList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.invoiceTemplatePageList.currentPage;
      pageList.pageSize = response.data.invoiceTemplatePageList.pageSize;
      pageList.totalCount = response.data.invoiceTemplatePageList.totalCount;
      this.setState({
        invoiceTemplate_list: invoiceTemplateList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new InvoiceTemplateSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadInvoiceTemplatePage(pageInput, criteria);
  };
  loadInvoiceTemplatePage = (pageList, searchCriteria) => {
    let criteria = new InvoiceTemplateSearchCriteria();
    criteria = searchCriteria;

    let requestInput = new RestInvoiceTemplateListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.InvoiceTemplateMaintenanceView_IsAccessible()) {
      MasterService.getInvoiceTemplatePageList(
        requestInput,
        this.loadInvoiceTemplateResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.invoiceTemplate_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ invoiceTemplate_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isInvoiceTemplateListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isInvoiceTemplateListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isInvoiceTemplateListFormOpen && (
          <InvoiceTemplateListForm
            invoiceTemplate_list={this.state.invoiceTemplate_list}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            invoiceTemplateData={this.state.invoiceTemplateData}
            editInvoiceTemplate={this.editInvoiceTemplate}
            deleteInvoiceTemplate={this.deleteInvoiceTemplate}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isInvoiceTemplateListFormOpen && (
          <InvoiceTemplateEntryForm
            invoiceTemplateData={this.state.invoiceTemplateData}
            closeInvoiceTemplateEntryForm={this.closeInvoiceTemplateEntryForm}
            saveInvoiceTemplate={this.saveInvoiceTemplate}
            editInvoiceTemplate={this.editInvoiceTemplate}
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}

function InvoiceTemplateAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <InvoiceTemplateList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default InvoiceTemplateAttributeModule;
